import { CLEAR_RECORDING_TO_PLAY, SET_RECORDING_TO_PLAY } from 'containers/Player/actions/recordings/constants';

const initialState = null;

const RecordingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RECORDING_TO_PLAY:
      return { ...state, ...action.recording };
    case CLEAR_RECORDING_TO_PLAY:
      return null;
    default:
      return state;
  }
}

export default RecordingsReducer;
